import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface LoyaltyCardServiceRef {
  id: number;
  name: string;
}

export interface LoyaltyCardMigrationMeta {
  clients_migrated: number;
  clients_with_progress: number;
}

export interface LoyaltyCard {
  id: number;
  tenant_id: number;
  name: string;
  stamps_required: number;
  reward_service_id: number;
  reward_validity_days?: number | null;
  is_active: boolean;
  services?: LoyaltyCardServiceRef[];
  reward_service?: LoyaltyCardServiceRef | null;
  migration?: LoyaltyCardMigrationMeta;
  created_at?: string;
  updated_at?: string;
}

export interface LoyaltyCardPayload {
  name: string;
  stamps_required: number;
  reward_service_id: number;
  reward_validity_days?: number | null;
  is_active?: boolean;
  service_ids: number[];
}

export interface LoyaltyMigrationPreview {
  clients_with_progress: number;
  merge_rule: string;
  service_ids: number[];
}

export interface LoyaltyShareLink {
  url: string;
  token: string;
  expires_at: number;
  qr_data_uri?: string | null;
}

export const listLoyaltyCards = (params?: {
  is_active?: boolean;
  per_page?: number;
}): Promise<ApiResponse<LoyaltyCard[]>> =>
  api.get<ApiResponse<LoyaltyCard[]>>("/loyalty-cards", params);

export const previewLoyaltyMigration = (params: {
  service_ids: number[];
  except_card_id?: number | null;
}): Promise<ApiResponse<LoyaltyMigrationPreview>> =>
  api.get<ApiResponse<LoyaltyMigrationPreview>>(
    "/loyalty-cards/migration-preview",
    {
      service_ids: params.service_ids,
      except_card_id: params.except_card_id ?? undefined,
    }
  );

export const createLoyaltyCard = (
  payload: LoyaltyCardPayload
): Promise<ApiResponse<LoyaltyCard>> =>
  api.create<ApiResponse<LoyaltyCard>>("/loyalty-cards", payload);

export const updateLoyaltyCard = (
  id: number,
  payload: Partial<LoyaltyCardPayload>
): Promise<ApiResponse<LoyaltyCard>> =>
  api.update<ApiResponse<LoyaltyCard>>(`/loyalty-cards/${id}`, payload);

export const deactivateLoyaltyCard = (
  id: number
): Promise<ApiResponse<LoyaltyCard>> =>
  api.delete<ApiResponse<LoyaltyCard>>(`/loyalty-cards/${id}`);

export const createClientLoyaltyShareLink = (
  clientId: number
): Promise<ApiResponse<LoyaltyShareLink>> =>
  api.create<ApiResponse<LoyaltyShareLink>>(
    `/clients/${clientId}/loyalty/share-link`,
    {}
  );
